import {Card, CardContent, CardHeader} from "@mui/material";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {FormattedMessage} from "react-intl";

export default function VatiaCheckoutSizes(props)
{
    return (
        props.sizeData.map((size, index) => {
            return <Card variant="outlined"
                         sx={{ maxWidth: 185, minWidth:175, minHeight:140, width: 150, display:"inline-block", marginRight:1, cursor: "pointer", fontWeight:600,
                             borderColor: props.selectedSize == index ? "green" : props.cards[index] }}
                         onClick={() => props.handleSizeSelection(size.title, size.price, index)}
                // onMouseEnter={(event) => {var cards = cards; cards[index] = 'black'; this.setState({cards:cards })}}
                // onMouseLeave={(event) => {var cards = cards; cards[index] = 'grey'; this.setState({cards:cards })}}
            >
                <CardHeader
                    title={<Typography sx={{color:"black", fontSize:28}}>
                        {/*<motion.div key={'check-1'} animate={{ opacity: selectedSize == index ? 1 : 0 }} initial="hide">*/}
                        {size.title}
                        <CheckCircleIcon style={{display:props.selectedSize == index ? 'inline-block' : 'none', color: "green", marginTop:10, marginBottom:10}}/>
                        {/*</motion.div>*/}
                    </Typography>}
                    // subheader={<Typography sx={{color:"grey", fontSize:14}}>{"Dr. Brauwolf Abo"}</Typography>}
                    subheader={<span style={{fontWeight:400, color:"grey", fontSize:12}}>CHF {size.price}.- / <FormattedMessage id={ 'abo.new.text.month' } defaultMessage={ 'Monat'} /></span>}
                    sx={{color:"black", size:30, fontWeight: 600}}
                />
                <CardContent style={{marginTop:0, paddingTop: 0}}>
                    {/*<p style={{fontWeight:400, color:"grey", fontSize:12}}>CHF {size.price}.- / Monat</p>*/}
                    <img style={{align:"center",paddingBottom:20,marginTop:0,marginLeft:"auto",marginRight:"auto",width:"100%",maxWidth:600}} src="/img/cbm_abo3.png"/>
                    <button style={{backgroundColor:"#f19800",border:0,borderRadius:4,color:"#fff",padding:6,marginTop:0, width: 130, height: 40, fontSize: 12}}
                            onClick={() => {props.handleNext()}}>
                        <FormattedMessage id={ 'abo.new.button.subscribe.now' } defaultMessage={ 'Jetzt abonnieren'} />
                    </button>
                    {/*{completed[0] != true ?*/}
                    {/*<motion.div key={'check-1'} animate={{ opacity: selectedSize == index ? 1 : 0 }} initial="hide">*/}
                    {/*    <CheckCircleIcon style={{display:selectedSize == index ? null : 'none', color: "green", marginTop:10, marginBottom:10}}/>*/}
                    {/*</motion.div>*/}
                    {/*}*/}
                </CardContent>
            </Card>
        })
    )
}